var map = {
	"./App": [
		5035,
		9
	],
	"./App.vue": [
		5035,
		9
	],
	"./assets/logo.png": [
		6949,
		1,
		949
	],
	"./components/keyboard": [
		9204,
		9
	],
	"./components/keyboard/": [
		9204,
		9
	],
	"./components/keyboard/index": [
		9204,
		9
	],
	"./components/keyboard/index.js": [
		9204,
		9
	],
	"./components/keyboard/index.worker": [
		3184,
		7,
		184
	],
	"./components/keyboard/index.worker.js": [
		3184,
		7,
		184
	],
	"./components/keyboard/key": [
		579,
		9
	],
	"./components/keyboard/key.js": [
		579,
		9
	],
	"./components/keyboard/keyboardIndex": [
		9115,
		9
	],
	"./components/keyboard/keyboardIndex.vue": [
		9115,
		9
	],
	"./components/keyboard/package": [
		376,
		3,
		376
	],
	"./components/keyboard/package.json": [
		376,
		3,
		376
	],
	"./data": [
		2737,
		9,
		737
	],
	"./data.js": [
		2737,
		9,
		737
	],
	"./dict/address": [
		7561,
		3,
		561
	],
	"./dict/address.json": [
		7561,
		3,
		561
	],
	"./dict/baseDict": [
		5184,
		3,
		651
	],
	"./dict/baseDict.json": [
		5184,
		3,
		651
	],
	"./dict/chowder": [
		1976,
		3,
		976
	],
	"./dict/chowder.json": [
		1976,
		3,
		976
	],
	"./main": [
		6293,
		9
	],
	"./main.js": [
		6293,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5323;
module.exports = webpackAsyncContext;